import * as React from "react";
import { InputProps } from "../IInputFieldProps";
import classNames from "classnames";
import { IPopupHint } from "../../../Interfaces/IPopupHint";

export interface RadioInputFieldOption {
  label: string;
  value: string;
  id: string;
  popupHint?: IPopupHint;
  explanation?: JSX.Element;
}

export interface RadioInputFieldProps {
  name: string;
  displayStyle: string;
  className?: string;
  options: RadioInputFieldOption[];
  addWrapperDivWithClass?: string;
  onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void | null;
  renderPopup?: (option: RadioInputFieldOption) => JSX.Element | null;
  input?: InputProps;
  inputRef?: React.RefCallback<HTMLInputElement>;
}

export const RadioInputField = (props: RadioInputFieldProps) => {
  const wrapperDivCheck = props.addWrapperDivWithClass && props.addWrapperDivWithClass?.length > 0;
  const labelClasses = wrapperDivCheck
    ? classNames("radioblock-item", props.className ? props.className : "")
    : classNames("radiobox-container", props.className ? props.className : "");

  const radioContainerClasses = wrapperDivCheck ? "radio-block-group" : "radio-box-group";

  return (
    <div
      className={radioContainerClasses}
      role="radiogroup"
      aria-labelledby={`radiogroup-label-${props.name}`}
    >
      {props.options &&
        props.options.map((option, index) => {
          const labelHtml = (
            <label
              className={labelClasses}
              key={index}
              id={`${option.id}-label`}
              style={{ display: props.displayStyle }}
            >
              <input
                {...props.input}
                id={option.id}
                type="radio"
                ref={props.inputRef}
                {...(props.name ? { name: props.name } : {})}
                value={option.value}
                checked={option.value === props.input?.value}
                onChange={props.onChange}
                role="radio"
                aria-checked={option.value === props.input?.value}
                aria-labelledby={`${option.id}-label`}
              />
              <span className="checkmark" />

              {option.label}
              {option.value === props.input?.value && option.explanation}
            </label>
          );

          if (wrapperDivCheck) {
            return (
              <div className={props.addWrapperDivWithClass} key={index}>
                {labelHtml}
                {props.renderPopup && props.renderPopup(option)}
              </div>
            );
          }

          return labelHtml;
        })}
    </div>
  );
};
